import React from "react";
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormHelperText,
  TextField,
  Grid2,
  Autocomplete,
  IconButton
} from "@mui/material";
// make sure to import like this

import { FormikErrors, FormikTouched, useFormikContext } from "formik";
import { colors } from "../../customer/data/Filter/color";
import { CreateProductRequest, ProductDetail } from "../../types/productType";
import ClearIcon from '@mui/icons-material/Clear';
const SIZES = ["FREE", "S", "M", "L", "XL"];
const CUSTOM_SIZE_VALUE = "__custom";
type Props = {
  idx: number;
  values: ProductDetail;
  handleChange: (e: React.ChangeEvent<any>) => void;
  isOnlyProduct:boolean;
  touched?: FormikTouched<ProductDetail>;
  errors?: FormikErrors<ProductDetail>;
  onRemove: (idx: number) => void;
  disableRemove?: boolean;
  onActivate?: (idx: number) => void;   // 👈 add this
};

function Row({
  idx,
  values,
  handleChange,
  isOnlyProduct,
  touched = {},
  errors = {},
  onRemove,
  disableRemove,
  onActivate
}: Props) {
 
const handleRemove = (idx: number) => { 
  onRemove(idx)
 }
  const { setFieldValue } = useFormikContext<CreateProductRequest>();
  return (
    <Grid2 container spacing={2} sx={{ mb: 1 }}>
      {/* Size */}
      <Grid2 size={{xs:12,md:4,lg:3}}>
        <FormControl  fullWidth required error={Boolean(touched.size && errors.size)}>
          {/* <InputLabel id={`size-${idx}`}>Sizes</InputLabel> */}
          <Autocomplete
          freeSolo                 // cho phép gõ custom
          options={SIZES}          // list size có sẵn
          value={values.size || ""} 
          onChange={(_, newValue) => {
            // khi chọn từ dropdown
            setFieldValue(`details[${idx}].size`, newValue || "");
          }}
          onInputChange={(_, newInputValue) => {
            // khi user gõ tay
            setFieldValue(`details[${idx}].size`, newInputValue || "");
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Sizes"
              required
              error={Boolean(touched?.size && errors?.size)}
              helperText={touched?.size && (errors?.size as string)}
            />
          )}
        />
          { touched.size && errors.size && (
            <FormHelperText>{errors.size as string}</FormHelperText>
          )}
          
        </FormControl>
      </Grid2>
            
      {/* Color */}
      <Grid2 size={{xs:12,md:4,lg:3}}>
        <FormControl fullWidth required error={Boolean(touched.color && errors.color)}>
          <InputLabel id={`color-${idx}`}>Color</InputLabel>
          <Select
            labelId={`color-${idx}`}
            name={`details[${idx}].color`}
            value={values.color}
            onChange={(e) =>
              handleChange(e as React.ChangeEvent<HTMLInputElement>) // 👈 convert
            }
            label="Color"
          >
            <MenuItem value="">
              <em>None</em>
            </MenuItem>
            {colors.map((c) => (
              <MenuItem key={c.name} value={c.name}>
                <div className="flex gap-3">
                  <span
                    style={{ backgroundColor: c.hex }}
                    className={`h-5 w-5 rounded-full ${
                      c.name === "White" ? "border" : ""
                    }`}
                  />
                  <p>{c.name}</p>
                </div>
              </MenuItem>
            ))}
          </Select>
          {touched.color && errors.color && (
            <FormHelperText>{errors.color as string}</FormHelperText>
          )}
        </FormControl>
      </Grid2>

      {/* Selling Price */}
      <Grid2 size={{xs:12,md:4,lg:3}}>
        <TextField
          fullWidth
          required
          label="Selling Price"
          name={`details[${idx}].sellingPrice`}
          value={values.sellingPrice}
          onChange={handleChange}
          error={Boolean(touched.sellingPrice && errors.sellingPrice)}
          helperText={touched.sellingPrice && (errors.sellingPrice as string)}
          inputMode="decimal"
        />
      </Grid2>

      {/* Stock */}
      <Grid2 size={{xs:12,md:4,lg:3}} className="relative">
        <TextField
          fullWidth
          required
          label="Stock"
          name={`details[${idx}].stock`}
          value={values.stock}
          onChange={handleChange}
          error={Boolean(touched.stock && errors.stock)}
          helperText={touched.stock && (errors.stock as string)}
          inputMode="numeric"
        />
      {!isOnlyProduct&&<IconButton onClick={() => { handleRemove(idx) }}  sx={{position:"absolute",top:0,right:0,transform:"translate(2%,2%)"}} className="w-[2rem] h-[2rem]" color="error">
        <ClearIcon/>
      </IconButton>}
      </Grid2>

      {/* Delete */}
      
    </Grid2>
  );
}

export const ProductDetailVariant = React.memo(Row);
